import { render, staticRenderFns } from "./CompaniesTable.vue?vue&type=template&id=23520498"
import script from "./CompaniesTable.vue?vue&type=script&lang=js"
export * from "./CompaniesTable.vue?vue&type=script&lang=js"
import style0 from "./CompaniesTable.vue?vue&type=style&index=0&id=23520498&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports